/**
 * @author wuTao
 * @description 单店报告
 * @Date 2023/05/30
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateCofig, templateConfig} from './config'
import {framework_tool, component_tool, utils_tool} from '@/tool'
import moment from "moment";
let { WizCard, WizCol, WizRow} = component_tool;
let {checkStrLength, Session} = utils_tool;
let {WizContainer, WizReduxTemplate} = framework_tool;
const formatterType = (val) => {
  let newVal;
  switch (val) {
    case 0 :
      newVal = '销售'
      break;
    case 1 :
      newVal = '售后'
      break;
    case 2 :
      newVal = ''
      break;
  }
  return newVal;
}
const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/storeReport/storeReportList/record') {
      if (history.location && history.location.record && history.location.record.id) {
        record = history.location.record
        Session.set('storeReportInfo', record);
      } else {
        record = Session.get('storeReportInfo') || {}
      }
    }
  }
  return record
}
class StoreReportRecordList extends WizContainer {

  componentName = 'StoreReportRecordList';

  constructor(props) {
    super(props);
    const {history} = props;
    let record = getParamRecord(history)
    this.state = {}
    this.initialValue = record;
  }

  _showTitle(record) {
    let content = <WizCard title={'单店报告信息'} bodyStyle={{paddingLeft: 20, paddingBottom: 25, paddingTop: 25}}>
      <WizRow>
        <WizCol span={2} offset={1} style={{textAlign: 'right'}}>品牌： </WizCol>
        <WizCol span={6} style={{textAlign: 'left'}}>{ record && record.brandName}</WizCol>
        <WizCol span={2} style={{textAlign: 'right'}}>类型： </WizCol>
        <WizCol span={4} style={{textAlign: 'left'}}>{
          // formatterType(record.importType)
          record && record.importTypeStr
        }</WizCol>
        <WizCol span={3} style={{textAlign: 'right'}}>状态： </WizCol>
        <WizCol span={6} style={{textAlign: 'left'}}>{ record && record.stateStr}</WizCol>
      </WizRow>
      <WizRow style={{marginTop: 20}}>
        <WizCol span={2} offset={1} style={{textAlign: 'right'}}>文件名称： </WizCol>
        <WizCol span={6} style={{textAlign: 'left'}}>{ record && record.importName}</WizCol>
        <WizCol span={2} style={{textAlign: 'right'}}>导入时间： </WizCol>
        <WizCol span={13} style={{textAlign: 'left'}}>{ record && formatterDateTime(record.importTime)}</WizCol>
      </WizRow>
    </WizCard>
    return content;
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let record = this.initialValue;
    const {id} = record;
    let _reduxTemplateCofig = reduxTemplateCofig({
      record,
      templateConfig: templateConfig( id,this,record),
      apiDataFormat: {},
      keepInitApiParams: true,
    })
    return <>{this._showTitle(record)}
      <WizCard title={'单店报告明细记录'}>
        <WizReduxTemplate {..._reduxTemplateCofig} style={{paddingTop: "100px"}}/>
      </WizCard>
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(StoreReportRecordList);
